import React from 'react'
import Toolbar from '@material-ui/core/Toolbar'
import withStyles from '@material-ui/core/styles/withStyles'
import IconButton from '@material-ui/core/IconButton'
import Icon from '@material-ui/core/Icon'
import withWidth from '@material-ui/core/withWidth'

import CommonHeaderItems from './CommonHeaderItems'
import HeaderSwitchApp from './HeaderSwitchApp'
import Logo from 'shared-ui/components/atoms/Logo'

const styles = ({ palette, spacing: { unit }, breakpoints }) => ({
  root: {
    height: 64,
    paddingLeft: 0,
    backgroundColor: palette.paper,
    color: palette.grey500,
    display: 'flex',
    boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.2)',
    justifyContent: 'space-between',
    width: '100%',
    boxSizing: 'border-box',
    position: 'fixed',
    top: 0,
    zIndex: 1100,
  },
  items: {
    display: 'flex',
    alignItems: 'center',
    '& > *+*': {
      marginLeft: unit,
    },
  },
})

class Header extends React.Component {
  state = {
    scrolled: false,
    showLogoutDialog: false,
  }

  render() {
    const {
      classes,
      member,
      handleDrawerToggle,
      data: { items = [] },
      platformName,
      version,
      width,
    } = this.props

    const switchAppItem = items.find(({ component }) => component === 'HeaderSwitchApp')
    const otherItems = items.filter(({ component }) => component !== 'HeaderSwitchApp')

    return (
      <Toolbar className={classes.root}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {(width === 'sm' || width === 'xs') && member && (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
            >
              <Icon>menu</Icon>
            </IconButton>
          )}
          {switchAppItem && <HeaderSwitchApp {...switchAppItem.props} />}
          <Logo
            platformName={platformName?.toUpperCase()}
            className={switchAppItem ? 'md:ml-0' : 'md:ml-4'}
          />
        </div>

        <div className={classes.items}>
          <CommonHeaderItems
            items={[
              ...otherItems,
              ...(version
                ? [
                    {
                      component: 'HeaderVersionItem',
                      props: { version },
                    },
                  ]
                : []),
            ]}
            member={member}
            width={width}
          />
        </div>
      </Toolbar>
    )
  }
}

export default withWidth()(withStyles(styles)(Header))
